import { render, staticRenderFns } from "./FlowyNewBlock.vue?vue&type=template&id=4a769086&lang=html&"
import script from "./FlowyNewBlock.vue?vue&type=script&lang=js&"
export * from "./FlowyNewBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports